import { Viewport } from 'pixi-viewport';
import { Application } from 'pixi.js';

export default (PIXI_WORLD_SIZES: Partial<ReturnType<typeof getPixiWorldSizes>>, withViewport = false) => {
  const app = new Application({
    ...PIXI_WORLD_SIZES.rendererSize,
    antialias: true,
    sharedTicker: false,
    powerPreference: 'high-performance',
    autoDensity: true
  });
  // @ts-ignore
  globalThis.__PIXI_APP__ = app;
  app.ticker.maxFPS = 30;
  app.ticker.speed = 0.5;
  app.stage.sortableChildren = true;

  if (withViewport) {
    const viewport = new Viewport({
      ...PIXI_WORLD_SIZES.viewportSizes,

      events: app.renderer.events
    });

    app.stage.addChild(viewport);

    viewport.drag({ wheel: false }).pinch().wheel({ trackpadPinch: true, wheelZoom: false }).decelerate();

    viewport.clamp({
      direction: 'all',
      underflow: 'top'
    });

    viewport.clampZoom({
      maxWidth: PIXI_WORLD_SIZES.clampMaxWidth,
      maxHeight: PIXI_WORLD_SIZES.clampMaxHeight,
      minWidth: PIXI_WORLD_SIZES.clampMinWidth,
      minHeight: PIXI_WORLD_SIZES.clampMinHeight
    });

    viewport.fit();

    return {
      app,
      viewport
    };
  } else {
    return {
      app,
      viewport: {} as Viewport
    };
  }
};
